export default __webpack_public_path__ + "static/media/fortaleza.22d19ada.jpeg";